<template>
  <br>
  <div style="display: flex; justify-content: space-between; background-color: #f0f0f0; padding: 10px; border-radius: 5px;">
    <h4 style="margin: 0;">Renovación de Suscripción: Selección de Plan</h4>
    <h4 style="margin: 0;">
      <span class="badge bg-primary">1</span>
      <span class="badge bg-primary">&nbsp;</span>
      <span class="badge bg-primary">&nbsp;</span>
      <span class="badge bg-primary">&nbsp;</span>
    </h4>
  </div>
  <hr>
  <div class="progress">
    <div class="progress-bar" role="progressbar" aria-label="Basic example" style="width: 25%" aria-valuenow="25"
      aria-valuemin="0" aria-valuemax="100"></div>
  </div>
  <br>
  <br>
  <div style="font-size: 20px; text-align: justify;">
    <strong>¡Gracias por seguir siendo parte de nuestra comunidad de atenciones médicas!</strong>
    <br>
    Es tiempo de renovar o actualizar tu plan. Selecciona el plan que mejor se adapte a tus necesidades actuales. 
    Cada plan está diseñado para ofrecer una variedad de características que satisfacen diferentes niveles de uso y demandas. 
    Explora las opciones disponibles y elige la mejor para continuar tu experiencia con nosotros.
  </div>
  <br>
  <section class="pricing py-5">
    <p>Planes Mensuales</p>
    <div class="container">
      <div class="row" style="justify-content: center; align-items: center; text-align: center;">
        <!-- Básico Tier -->
        <div class="col-lg-3">
          <div class="card mb-5 mb-lg-0">
            <div class="card-body">
              <h5 class="card-title text-muted text-uppercase text-center" style="background-color: lightyellow; padding: 5px;">
                Básico
              </h5>
              <h6 class="card-price text-center">$10<span class="period">/mes</span></h6>
              <hr>
              <ul class="fa-ul">
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Usuario Único</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>5GB de Almacenamiento</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Proyectos Públicos Ilimitados</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Acceso a la Comunidad</li>
                <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span>Proyectos Privados Ilimitados</li>
                <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span>Soporte Telefónico Dedicado</li>
                <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span>Subdominio Gratuito</li>
                <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span>Reportes de Estado Mensuales</li>
              </ul>
              <div class="d-grid">
                <button type="submit" class="btn btn-primary mb-3" @click="renovarBasico()">Renovar ></button>
              </div>
            </div>
          </div>
        </div>
        <!-- Plus Tier -->
        <div class="col-lg-3">
          <div class="card mb-5 mb-lg-0">
            <div class="card-body">
              <h5 class="card-title text-muted text-uppercase text-center" style="background-color: lightpink; padding: 5px;">
                Plus
              </h5>
              <h6 class="card-price text-center">$20<span class="period">/mes</span></h6>
              <hr>
              <ul class="fa-ul">
                <li><span class="fa-li"><i class="fas fa-check"></i></span><strong>5 Usuarios</strong></li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>50GB de Almacenamiento</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Proyectos Públicos Ilimitados</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Acceso a la Comunidad</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Proyectos Privados Ilimitados</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Soporte Telefónico Dedicado</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Subdominio Gratuito</li>
                <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span>Reportes de Estado Mensuales</li>
              </ul>
              <div class="d-grid">
                <button type="submit" class="btn btn-primary mb-3" @click="renovarPlus()">Renovar ></button>
              </div>
            </div>
          </div>
        </div>
        <!-- Pro Tier -->
        <div class="col-lg-3">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-muted text-uppercase text-center" style="background-color: lightskyblue; padding: 5px;">
                Pro
              </h5>
              <h6 class="card-price text-center">$45<span class="period">/mes</span></h6>
              <hr>
              <ul class="fa-ul">
                <li><span class="fa-li"><i class="fas fa-check"></i></span><strong>Usuarios Ilimitados</strong></li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>150GB de Almacenamiento</li>
                <li><span class="fa-li"><i the="fas fa-check"></i></span>Proyectos Públicos Ilimitados</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Acceso a la Comunidad</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Proyectos Privados Ilimitados</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Soporte Telefónico Dedicado</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span><strong>Subdominios Gratuitos Ilimitados</strong></li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Reportes de Estado Mensuales</li>
              </ul>
              <div class="d-grid">
                <button type="submit" class="btn btn-primary mb-3" @click="renovarPro()">Renovar ></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="pricing py-5">
    <p>Planes anuales con 10% de descuento</p>
    <div class="container">
      <div class="row" style="justify-content: center; align-items: center; text-align: center;">        
        <!-- Silver Tier -->
        <div class="col-lg-3">
          <div class="card mb-5 mb-lg-0">
            <div class="card-body">
              <h5 class="card-title text-muted text-uppercase text-center" style="background-color: lightyellow; padding: 5px;">
                Silver
              </h5>
              <h6 class="card-price text-center">$10<span class="period">/mes</span></h6>
              <hr>
              <ul class="fa-ul">
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Usuario Único</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>5GB de Almacenamiento</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Proyectos Públicos Ilimitados</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Acceso a la Comunidad</li>
                <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span>Proyectos Privados Ilimitados</li>
                <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span>Soporte Telefónico Dedicado</li>
                <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span>Subdominio Gratuito</li>
                <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span>Reportes de Estado Mensuales</li>
              </ul>
              <div class="d-grid">
                <button type="submit" class="btn btn-primary mb-3" @click="renovarSilver()">Renovar ></button>
              </div>
            </div>
          </div>
        </div>
        <!-- Gold Tier -->
        <div class="col-lg-3">
          <div class="card mb-5 mb-lg-0">
            <div class="card-body">
              <h5 class="card-title text-muted text-uppercase text-center" style="background-color: lightpink; padding: 5px;">
                Gold
              </h5>
              <h6 class="card-price text-center">$20<span class="period">/mes</span></h6>
              <hr>
              <ul class="fa-ul">
                <li><span class="fa-li"><i class="fas fa-check"></i></span><strong>5 Usuarios</strong></li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>50GB de Almacenamiento</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Proyectos Públicos Ilimitados</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Acceso a la Comunidad</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Proyectos Privados Ilimitados</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Soporte Telefónico Dedicado</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Subdominio Gratuito</li>
                <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span>Reportes de Estado Mensuales</li>
              </ul>
              <div class="d-grid">
                <button type="submit" class="btn btn-primary mb-3" @click="renovarGold()">Renovar ></button>
              </div>
            </div>
          </div>
        </div>
        <!-- Platinum Tier -->
        <div class="col-lg-3">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-muted text-uppercase text-center" style="background-color: lightskyblue; padding: 5px;">
                Platinum
              </h5>
              <h6 class="card-price text-center">$45<span class="period">/mes</span></h6>
              <hr>
              <ul class="fa-ul">
                <li><span class="fa-li"><i class="fas fa-check"></i></span><strong>Usuarios Ilimitados</strong></li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>150GB de Almacenamiento</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Proyectos Públicos Ilimitados</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Acceso a la Comunidad</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Proyectos Privados Ilimitados</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Soporte Telefónico Dedicado</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span><strong>Subdominios Gratuitos Ilimitados</strong></li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Reportes de Estado Mensuales</li>
              </ul>
              <div class="d-grid">
                <button type="submit" class="btn btn-primary mb-3" @click="renovarPlatinum()">Renovar ></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Home',
  components: {
  },
  data() {
    return {
      email: ""
    }
  },
  methods: {
    login() {
      this.$router.push('Login')
    },
    modal() {
      this.$router.push('App')
    },
    renovarGratis() {
      window.sessionStorage.setItem("nombrePlan", "Gratis");
      window.sessionStorage.setItem("idPlan", "1");
      this.$router.push('Renovacion02TC')
    },
    renovarBasico() {
      window.sessionStorage.setItem("nombrePlan", "Básico");
      window.sessionStorage.setItem("idPlan", "2");
      this.$router.push('Renovacion02TC')
    },
    renovarPlus() {
      window.sessionStorage.setItem("nombrePlan", "Plus");
      window.sessionStorage.setItem("idPlan", "3");
      this.$router.push('Renovacion02TC')
    },
    renovarPro() {
      window.sessionStorage.setItem("nombrePlan", "Pro");
      window.sessionStorage.setItem("idPlan", "4");
      this.$router.push('Renovacion02TC')
    },
    renovarSilver() {
      window.sessionStorage.setItem("nombrePlan", "Silver");
      window.sessionStorage.setItem("idPlan", "5");
      this.$router.push('Renovacion02TC')
    },
    renovarGold() {
      window.sessionStorage.setItem("nombrePlan", "Gold");
      window.sessionStorage.setItem("idPlan", "6");
      this.$router.push('Renovacion02TC')
    },
    renovarPlatinum() {
      window.sessionStorage.setItem("nombrePlan", "Platinum");
      window.sessionStorage.setItem("idPlan", "7");
      this.$router.push('Renovacion02TC')
    },
  }
}
</script>
<style src="@/assets/css/tarjetas.css" scoped></style>
